import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import { toast } from "react-toastify"
import axios from "axios"
import { liveOrderDefaultURL } from '../../../components/CommonApis/CommonLiveOrderApi';
import { adminApiHeader } from '../../../components/CommonApis/CommonApiUrl';
import Response_Processing from '../../../layout/Others/Response_Processing';
import AdminBackNavigation from '../../../components/CommonComponents/AdminBackNavigation';
import AdminSaveHeader from '../../../components/CommonComponents/AdminSaveHeader';
import Wrapper from '../../../components/CommonComponents/Wrapper';
import MessageLabel from '../../../components/CommonComponents/MessageLabel';
import AdminCustomInput from '../../../components/CommonComponents/AdminCustomInput';

const LiveOrderEdit = () => {
    const { id } = useParams();
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [apiData, setApiData] = useState([]);
    const [showOverlay, setShowOverlay] = useState(false);
    useEffect(() => {
        fetchData()
    }, [withOutRefresh])

    const fetchData = async () => {
        try {
            setShowOverlay(true)
            const response = await axios.get(`${liveOrderDefaultURL?.editApi}/${id}`, { headers: adminApiHeader })
            const result = response?.data?.Web_Livestream_HomePage_Order;
            if (response?.data?.status) {
                setApiData(result)
                setShowOverlay(false)
            }
            else {
                toast.error(response?.data?.message)
                setShowOverlay(false)
            }

        }
        catch (error) {
            const errMessage = error?.response?.data?.message
            console.error(errMessage)
        }
    }

    const handleInput = (e) => {
        const { name, value } = e.target;
        setApiData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };


    const [validationMessageheader_name, setValidationMessageheader_name] =
        useState("");
    const [isValidationHiddenheader_name, setIsValidationHiddenheader_name] =
        useState(true);

    const [validationMessageurl, setValidationMessageurl] =
        useState("");
    const [isValidationHiddenurl, setIsValidationHiddenurl] =
        useState(true);

    const header_nameInputRef = useRef(null);
    const url_nameInputRef = useRef(null);

    const handleUpdate = async (e) => {
        try {


            let focusInputRef = null;

            if (apiData?.header_name === "") {
                setValidationMessageheader_name("Header Name cannot be empty.");
                setIsValidationHiddenheader_name(false);
                focusInputRef = header_nameInputRef;
            }

           if (!apiData?.url || apiData.url.trim() === "") {
                setValidationMessageurl("Slug cannot be empty.");
                setIsValidationHiddenurl(false);
                focusInputRef = url_nameInputRef;
            }

            if (focusInputRef) {
                focusInputRef.current.focus();
                return;
            }

            e.preventDefault();

            setShowOverlay(true)
            const formData = new URLSearchParams();
            for (const key in apiData) {
                if (['id', 'header_name', 'url'].includes(key)) {
                    const value = apiData[key] ?? "";
                    formData.append(key, value);
                }
            }
            const response = await axios.post(`${liveOrderDefaultURL?.updateApi}`, formData,
                {
                    headers: {
                        ...adminApiHeader,
                        'Content-Type': 'application/x-www-form-urlencoded' // Specify the content type
                    }
                }
            )
            if (response?.data?.status) {
                setValidationMessageheader_name("");
                setValidationMessageurl("");
                toast.success(response?.data?.message)
                setShowOverlay(false)
                setWithOutRefresh(!withOutRefresh)
            }
            else {
                setIsValidationHiddenheader_name(false);
                setIsValidationHiddenurl(false);
                toast.error(response?.data?.message)
                setShowOverlay(false)
            }

        }
        catch (error) {
            const errMessage = error?.response?.data?.message
            console.error(errMessage)
        }
    }
    return (
        <div>
            {showOverlay && (<Response_Processing />)}
            {<AdminBackNavigation path={`${'/live-settings'}`} text="Back" />}
            <AdminSaveHeader heading="Edit Order Live " saveText="Update Order" saveMethod={handleUpdate} />
            <Wrapper>
                <MessageLabel text="Show Header Name" className="mandatorySimple" />
                <AdminCustomInput type="text" name="header_name" value={apiData?.header_name} onChange={handleInput} placeHolder={"header name"} error={validationMessageheader_name} />
                <MessageLabel text='Slug' className="mandatorySimple" />
                <AdminCustomInput type="text" name="url" value={apiData?.url} onChange={handleInput} placeHolder={"Site url"} error={validationMessageurl} />
            </Wrapper>
        </div>
    )
}

export default LiveOrderEdit